var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dropdown-block"},[_c('label',[_vm._v(" "+_vm._s(_vm.label)+" "),_c('item-icon',{attrs:{"information":_vm.information}})],1),_c('codd-toggle',{attrs:{"val":_vm.val},on:{"codd_input":_vm.onInputChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }